import React, { useEffect, useState } from 'react';

import {
  CorrectIndicator,
  Option, OptionContainer,
} from './index.styles';

interface MultipleChoiceProps {
  options: number;
  correctOption: number;
  isMarked: boolean;
  onSelect?: (option: number) => void;
  selectedOption?: number;
  disabled?: boolean;
}

const MultipleChoiceSelect = ({
  options,
  correctOption,
  isMarked,
  onSelect = () => {},
  selectedOption = 0,
  disabled = false,
}: MultipleChoiceProps) => {
  const [isCorrect, setIsCorrect] = useState(false);

  const optionLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.slice(0, options);

  const handleClick = (option: number) => {
    if (disabled) return;

    if (selectedOption === option) {
      onSelect(0);
    } else {
      onSelect(option);
    }
  };

  useEffect(() => {
    setIsCorrect(selectedOption === correctOption);
  }, [selectedOption]);

  return (
    <OptionContainer>
      {optionLetters.split('').map((letter, index) => {
        const option = index + 1;

        const isSelected = selectedOption === option;
        const isOptionCorrect = correctOption === option;

        return (
          <Option
            key={letter}
            onClick={() => handleClick(option)}
            isSelected={isSelected}
            isMarked={isMarked}
            isCorrect={isOptionCorrect}
            disabled={disabled}
          >
            {letter}
          </Option>
        );
      })}
      {isMarked && (
        <CorrectIndicator isCorrect={isCorrect}>
          {isCorrect ? '✓' : '✗'}
        </CorrectIndicator>
      )}
    </OptionContainer>
  );
};

export default MultipleChoiceSelect;
